/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Container, Image } from 'semantic-ui-react';
import VerifyEmailForm from '../containers/VerifyEmailForm';

const StyledContainer = styled(Container)`
    align-items: center;
    justify-content: center;
    display: flex !important;
    height: 100vh;
`;

const Content = styled.div`
    width: 500px;
`;

const Logo = styled(Image)`
    margin: 0 auto 3em auto;
`;

const VerifyEmailPage = ({ match }) => (
    <StyledContainer fluid>
        <Content>
            <Logo src="/images/appotime-logo-dashboard.png" />
            <VerifyEmailForm
                token={match.params.token}
                email={match.params.email}
            />
        </Content>
    </StyledContainer>
);

export default VerifyEmailPage;
